import checkObject from './checkObject'
const configAr = {
    solicitingProposals: {//征集提案
        accordingToInformation: [checkObject.redStarLogo],
        programme: [checkObject.redStarLogo],
        causeOfAction: [checkObject.redStarLogo],
    },
    hospitalization: {  //住院慰问
        name: [checkObject.redStarLogo],
        type: [checkObject.redStarLogo],
        declare: [checkObject.redStarLogo],//
        imgData: [checkObject.redStarLogo],//
        desc: [checkObject.redStarLogo],//
        data: [checkObject.upload]
    },
    death: { //去世
        name: [checkObject.redStarLogo],
        applyMoney: [checkObject.redStarLogo],
        applyGoods: [checkObject.redStarLogo],
        type: [checkObject.redStarLogo],
        imgData: [checkObject.redStarLogo],
        data: [checkObject.upload]
    },
    rescue: { //大病救助
        desc: [checkObject.redStarLogo],
        name: [checkObject.redStarLogo],
        imgData: [checkObject.redStarLogo],
        data: [checkObject.upload],
    },
    sympathy: {//其他慰问
        name: [checkObject.redStarLogo],
        imgData: [checkObject.redStarLogo],
        desc: [checkObject.redStarLogo],
        comfortType: [checkObject.redStarLogo],
        data: [checkObject.redStarLogo],
    },
    subsidy: {//困难补助
        name: [checkObject.redStarLogo],
        imgData: [checkObject.redStarLogo],
        desc: [checkObject.redStarLogo],
        applyMoney: [checkObject.redStarLogo],
        data: [checkObject.redStarLogo],
    }
}
export default configAr;